export const sortCaseData = async (filteredCaseList, caseSort) => {
  const caseData = JSON.parse(JSON.stringify(filteredCaseList));

  if (caseSort.key === 'adminName') {
    if (caseSort.order === 'ascending') {
      caseData.sort((a, b) =>
        (a.admin && a.admin.firstName ? a.admin.firstName.toLowerCase() : '') >
          (b.admin && b.admin.firstName ? b.admin.firstName.toLowerCase() : '') ? 1 :
          (a.admin && a.admin.firstName ? a.admin.firstName.toLowerCase() : '') <
            (b.admin && b.admin.firstName ? b.admin.firstName.toLowerCase() : '') ? -1 : 0 || ' '
      );
    } else if (caseSort.order === 'descending') {
      caseData.sort((a, b) =>
        (b.admin && b.admin.firstName ? b.admin.firstName.toLowerCase() : '') >
          (a.admin && a.admin.firstName ? a.admin.firstName.toLowerCase() : '') ? 1 :
          (b.admin && b.admin.firstName ? b.admin.firstName.toLowerCase() : '') <
            (a.admin && a.admin.firstName ? a.admin.firstName.toLowerCase() : '') ? -1 : 0 || ' '
      );
    }
  } else if (caseSort.key === 'Contact_First_Name__c') {
    caseData.sort((a, b) => {
      const nameA = a.Contact_First_Name__c?.toLowerCase() || '';
      const nameB = b.Contact_First_Name__c?.toLowerCase() || '';
      if (caseSort.order === 'ascending') {
        return nameA > nameB ? 1 : nameA < nameB ? -1 : 0;
      } else if (caseSort.order === 'descending') {

        return nameA < nameB ? 1 : nameA > nameB ? -1 : 0;
      }

      return 0;
    });
  } else if (caseSort.key !== 'caseDate') {
    caseData.sort((a, b) => {
      const nameA = a[caseSort.key]?.toLowerCase() || '';
      const nameB = b[caseSort.key]?.toLowerCase() || '';
      if (caseSort.order === 'ascending') {
        return nameA > nameB ? 1 : nameA < nameB ? -1 : 0;
      } else if (caseSort.order === 'descending') {

        return nameA < nameB ? 1 : nameA > nameB ? -1 : 0;
      }

      return 0;
    });
  } else if (caseSort.order === 'ascending') {
    caseData.sort((a, b) => new Date(a[caseSort.key]).getTime() > new Date(b[caseSort.key]).getTime() ? 1 : new Date(a[caseSort.key]).getTime() < new Date(b[caseSort.key]).getTime() ? -1 : 0);
  } else if (caseSort.order === 'descending') {
    caseData.sort((a, b) => new Date(a[caseSort.key]).getTime() < new Date(b[caseSort.key]).getTime() ? 1 : new Date(a[caseSort.key]).getTime() > new Date(b[caseSort.key]).getTime() ? -1 : 0);
  }
  filteredCaseList = JSON.parse(JSON.stringify(caseData));

  return filteredCaseList;
};